import { render, staticRenderFns } from "./DashboardActions.vue?vue&type=template&id=240070ae&scoped=true&"
import script from "./DashboardActions.vue?vue&type=script&lang=ts&"
export * from "./DashboardActions.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardActions.vue?vue&type=style&index=0&id=240070ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240070ae",
  null
  
)

export default component.exports